import { Settings } from '../models';
import { settingsApi } from './settings';

export type SettingsState = { [settingsApi.reducerPath]: NonNullable<Parameters<typeof settingsApi.reducer>[0]> };

export const getSettings = (state: SettingsState): Settings | undefined =>
  settingsApi.endpoints.getSettings.select()(state).data;
